import { Component, OnInit, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { Book } from '../../../classes/book';
import { BookForm } from './book-form';
import { PromoWizardService } from '../../../core/services/data/promo-wizard.service';

@Component({
	selector: 'app-wizard-edit-book',
	templateUrl: './edit-book.component.html',
	styleUrls: ['./edit-book.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})

export class PromoWizardEditBookComponent implements OnInit {
	@Output() bookModified = new EventEmitter<Book>();

	public book: Book;

	public bookComponents = new BookForm();

	public editBookForm: UntypedFormGroup;

	public newLinkForm: UntypedFormGroup = new UntypedFormGroup({
		type: new UntypedFormControl(),
		link: new UntypedFormControl(),
	});

	public uploadError: string;

	public uploading = false;

	public showNewLinkForm = false;

	public linkTypes = [
		{ value: 'apple', label: 'Apple Books' },
		{ value: 'nook', label: 'Nook' },
		{ value: 'kobo', label: 'Kobo' },
		{ value: 'googleplay', label: 'Google Play' },
	];

	public defaultCoverImage = '/assets/img/defaults/default_book_image_400w_simple.jpg';

	public queryPromoPrice: number;

	constructor(
		public promoWizardService: PromoWizardService,
	) {
	}

	ngOnInit(): void {
		this.book = this.promoWizardService.selectedBook;
		this.editBookForm = new UntypedFormGroup({
			title: new UntypedFormControl(this.book?.title),
			author: new UntypedFormControl(this.book?.author),
			description: new UntypedFormControl(this.book?.description),
			promo_price: new UntypedFormControl(this.promoWizardService.bookPromoPrice),
			kindleUnlimited: new UntypedFormControl(),
			kindleCountdownDeal: new UntypedFormControl(),
			amazonLink: new UntypedFormControl(this.book?.amazonLink),
			apple: new UntypedFormControl(this.book?.whereAvailable.apple),
			nook: new UntypedFormControl(this.book?.whereAvailable.nook),
			kobo: new UntypedFormControl(this.book?.whereAvailable.kobo),
			googleplay: new UntypedFormControl(this.book?.whereAvailable.googleplay),
			bookLength: new UntypedFormControl(this.book?.bookLength),
			nameOfSeries: new UntypedFormControl(this.book?.nameOfSeries),
			numberOfBooksInSeries: new UntypedFormControl(this.book?.numberOfBooksInSeries),
			bookNumber: new UntypedFormControl(this.book?.bookNumber),
			isSeries: new UntypedFormControl(this.book?.isSeries),
			terms: new UntypedFormControl(false),
		});

		this.editBookForm.valueChanges.subscribe((item) => {
			const bookProperties = {
				title: item.title,
				author: item.author,
				description: item.description,
				amazonLink: item.amazonLink,
				whereAvailable: {
					apple: item.apple,
					nook: item.nook,
					kobo: item.kobo,
					googleplay: item.googleplay,
				},
				bookNumber: item.bookNumber,
				bookLength: item.bookLength,
				nameOfSeries: item.nameOfSeries,
				numberOfBooksInSeries: item.numberOfBooksInSeries,
			};

			this.promoWizardService.kindleCountdownDeal = item.kindleCountdownDeal;
			this.promoWizardService.kindleUnlimited = item.kindleUnlimited;
			this.promoWizardService.bookPromoPrice = item.promo_price;
			this.promoWizardService.termsAccepted = item.terms;

			const book = Object.assign(this.book, bookProperties);

			this.bookModified.emit(book);
			this.promoWizardService.bookModified(book);
		});
	}

	addInput(idLink) {
		const id = `${idLink}_field`;
		document.getElementById(id).style.display = 'block';
		this.book[this.newLinkForm.value.type] = this.newLinkForm.value.link;
		this.newLinkForm.reset();
	}

	deleteInput(idLink) {
		const id = `${idLink}_field`;
		document.getElementById(id).style.display = 'none';
		const object = { idLink: '' };

		this.editBookForm.patchValue(object);
		this.editBookForm.controls[idLink].setValue('');
	}

	bookCoverUpload(result) {
		if (result && this.book) {
			this.book.amazonImageUrl = result.publicUrl;
		}
	}

	bookCoverUploadError(error) {
		this.uploadError = error;
	}

	isUploadingBookCover(uploading) {
		this.uploading = uploading;
	}

	showAddLinkForm() {
		this.showNewLinkForm = true;
	}

	displayPromoPriceField() {
		return this.queryPromoPrice > 0;
	}
}
